import React from 'react';
import { Button } from '@/components/ui/button';

type Props = {
  children: React.ReactNode;
  onReset?: () => void;
};

type State = {
  error: Error | null;
};

export default class SingularityErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    // Keep this minimal; we mainly want to avoid unmounting the whole run UI.
    // eslint-disable-next-line no-console
    console.error('[Singularity] Orchestration3D crashed:', error);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="h-full w-full flex items-center justify-center bg-black text-white">
          <div className="max-w-lg w-full p-6 rounded-lg border border-white/10 bg-white/5">
            <div className="text-lg font-semibold">Singularity paused</div>
            <div className="text-sm text-white/70 mt-2">
              The 3D orchestration view hit an error while rendering a burst of events.
            </div>
            <pre className="mt-4 max-h-40 overflow-auto text-xs bg-black/40 rounded p-3 border border-white/10 whitespace-pre-wrap break-words">
              {String(this.state.error?.message || this.state.error)}
            </pre>
            <div className="mt-4 flex items-center justify-end gap-2">
              <Button
                variant="outline"
                className="border-white/15 text-white hover:bg-white/10"
                onClick={() => {
                  this.setState({ error: null });
                  this.props.onReset?.();
                }}
              >
                Try again
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
